module.exports = "/img/iqos_logo_mobile.svg?4dce2fcef41efcf0829b80b3c0575cab";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/iqos/iqos_logo_mobile.svg
// module id = VbOD
// module chunks = 44